var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 6.43945L8.26473 10.9542C8.33699 10.8877 8.41559 10.8161 8.49998 10.74C8.97782 10.3091 9.6451 9.73284 10.3998 9.15472C11.1518 8.57866 12.006 7.9889 12.8565 7.53996C13.6889 7.10063 14.6021 6.75011 15.45 6.75011C18.4689 6.75011 21 9.05576 21 12.0001C21 14.9445 18.4689 17.2501 15.45 17.2501C14.6021 17.2501 13.6889 16.8996 12.8565 16.4603C12.006 16.0113 11.1518 15.4216 10.3998 14.8455C9.6451 14.2674 8.97782 13.6911 8.49998 13.2603C8.41559 13.1842 8.33699 13.1125 8.26473 13.046L3.75 17.5608V6.43945ZM9.34352 12.0001C9.39427 11.9537 9.44797 11.9049 9.50444 11.854C9.96238 11.4411 10.598 10.8924 11.312 10.3455C12.0286 9.79657 12.8087 9.26132 13.5567 8.86651C14.3229 8.46209 14.9725 8.25011 15.45 8.25011C17.7331 8.25011 19.5 9.97391 19.5 12.0001C19.5 14.0263 17.7331 15.7501 15.45 15.7501C14.9725 15.7501 14.3229 15.5381 13.5567 15.1337C12.8087 14.7389 12.0286 14.2037 11.312 13.6547C10.598 13.1078 9.96238 12.5591 9.50444 12.1462C9.44797 12.0953 9.39427 12.0465 9.34352 12.0001ZM7.18934 12.0001L5.25 10.0608V13.9395L7.18934 12.0001Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.875C18 11.4963 17.4963 12 16.875 12C16.2537 12 15.75 11.4963 15.75 10.875C15.75 10.2537 16.2537 9.75 16.875 9.75C17.4963 9.75 18 10.2537 18 10.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFish);
export default __webpack_public_path__ + "static/media/fish.b32e37dc6f071547fcd9f77970d989ad.svg";
export { ForwardRef as ReactComponent };